import { createSelector } from '@reduxjs/toolkit';

import { State } from 'types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.CompensationSentence;

export const statusSelector = createSelector(rootSelector, (state) => state.status);

export const errorSelector = createSelector(rootSelector, (state) => state.error);

export default {
  statusSelector,
  errorSelector,
};
